import {Component, EventEmitter, Input, Output} from '@angular/core';

export enum OPTIONS_POSITION {
  TOP = 'dropdown-on-top',
  BOTTOM = 'dropdown-on-bottom'
}

@Component({
  selector: 'beaconstac-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss'],
})
export class OptionsComponent {

  /**
   * width of list
   */
  @Input()
  maxWidth: string;

  /**
   * custom class for orientation handling
   */
  @Input()
  optionsPosition: OPTIONS_POSITION;

  /**
   * height of list
   */
  @Input()
  maxHeight: string = '200px';

  /**
   * Label field from custom object
   */
  @Input()
  optionLabelField = 'name';

  /**
   * Tooltip text for Label field from custom object
   */
  @Input()
  optionLabelFieldTooltip = 'nameTooltip';

  /**
   * Value field from custom object
   */
  @Input()
  optionValueField = 'value';

  /**
   * Secondary value field from custom object
   */
  @Input()
  optionSecondaryLabelField = 'secondaryValue';

  /**
   * Content of list
   */
  @Input()
  listItems = [];

  /**
   * Selected value
   */
  @Input()
  value: any;

  /**
   * Value change emitter
   */
  @Output()
  valueChange: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  stickyCTAClicked: EventEmitter<any> = new EventEmitter<any>();

  /**
   * If specific output is required from custom object
   */
  @Input()
  specificOutput = '';

  /**
   * Specific output emitter
   */
  @Output()
  specificOutputChange = new EventEmitter<any>();

  /**
   * Should highlight selected value or not
   */
  @Input()
  highlightSelectedValue = true;

  @Input()
  optionsType = 1

  @Input()
  isFetchingData = false;

  @Input()
  enableInfiniteScrolling = false;
  /*
  * optionsHeader is used to display a header in the options dropdown
   */
  @Input()
  optionsHeaderText = '';

  @Input()
  stickyCTAText = '';

  @Output()
  fetchMoreData: EventEmitter<null> = new EventEmitter();

  onModalScrollDown() {
    if( this.enableInfiniteScrolling ) {
      this.fetchMoreData.emit();
    }
  }

  setValue(item) {
    if (!item.hasOwnProperty('isHeader')) {
        if (item.hasOwnProperty('isClickable') && (item.isClickable === false)) {
          return;
        }
        if (!item.isPremium) {
          this.value = item;
        }
        this.valueChange.next(item);
        if (this.specificOutput) {
            this.specificOutputChange.emit(item[this.specificOutput]);
        }
    }
  }

  // Optimization for ngFor: https://netbasal.com/angular-2-improve-performance-with-trackby-cc147b5104e5
  trackByFn(index, item) {
    return index;
  }

}
